import {BrowserRouter as Router, Switch, Route} from "react-router-dom";
import "./styles/app.sass";
import Page from "./components/Page";
import Home from "./screens/Home";
import UploadDetails from "./screens/UploadDetails";
import Faq from "./screens/Faq";
import Search01 from "./screens/Search01";
import Profile from "./screens/Profile";
import ProfileEdit from "./screens/ProfileEdit";
import Item from "./screens/Item";
import Web3ContextWrapper from "./contexts/Web3Context";

function App() {
  return (
    <Web3ContextWrapper>
      <Router>
        <Switch>
          <Route
            exact
            path="/"
            render={() => (
              <Page>
                <Home/>
              </Page>
            )}
          />
          <Route
            exact
            path="/upload-details"
            render={() => (
              <Page className="upload-page">
                <UploadDetails/>
              </Page>
            )}
          />
          <Route
            exact
            path="/faq"
            render={() => (
              <Page>
                <Faq/>
              </Page>
            )}
          />
          <Route
            exact
            path="/search"
            render={() => (
              <Page>
                <Search01/>
              </Page>
            )}
          />
          <Route
            exact
            path="/profile/:address"
            render={() => (
              <Page>
                <Profile/>
              </Page>
            )}
          />
          <Route
            exact
            path="/profile"
            render={() => (
              <Page>
                <Profile/>
              </Page>
            )}
          />
          <Route
            exact
            path="/profile-edit"
            render={() => (
              <Page>
                <ProfileEdit/>
              </Page>
            )}
          />
          <Route
            exact
            path="/item/:seo_url"
            render={() => (
              <Page>
                <Item/>
              </Page>
            )}
          />
        </Switch>
      </Router>
    </Web3ContextWrapper>
  );
}

export default App;
